export default class ImagePreviewModel {
  ImageSrc? = "";
  Width: number;
  Height: number;
  Top: number;
  Left: number;
}
